module.exports = __webpack_public_path__ + "static/media/paypal_gray.40a7b705.svg";